import reducer from './orderSlice'
import { orderActions } from './orderSlice'
import * as orderSelectors from './selectors'

export { orderSelectors, orderActions }
export default reducer
